import {BaseFilterHelper} from "../../../common/utils/filter/base-filter-helper";
import {SalesWrapper} from "../sales/sales-wrapper";

export class FilterHelper extends BaseFilterHelper {
  constructor() {
    super();
  }

  applyFilter(salesWrapper: SalesWrapper, salesWrapperCache: SalesWrapper): void {
    // combine baseOrderElements and cachedBaseOrderElements
    salesWrapper.setBaseOrderElements([...salesWrapper.getBaseOrderElements(), ...salesWrapperCache.getBaseOrderElements()]);
    salesWrapperCache.clear();
    for (let filter of this.filter) {
      let i = 0;
      let len = salesWrapper.length();
      while (i < len) {
        // check if element needs to be filtered out
        // @ts-ignore
        if (salesWrapper.getByIndex(i)[filter.key] === filter.value) {
          salesWrapperCache.append(salesWrapper.getByIndex(i));
          salesWrapper.removeElementByIndex(i);
          len--;
        } else {
          i++;
        }
      }
    }

  }
}
